module.exports = __webpack_public_path__ + "img/car1.c1a96daa.png";